<template>
<div>

      <div v-if="widthMax > 768">
            <div class="headPage py-3">
                  <div class="container">
                        <div class="row">
                              <div :class="user != '' && user != null ? 'col-sm-6':'col-12 text-center'" class="text-white font-weight-bold font-30">
                                    <router-link class="text-white" :to="user != '' && user != null ? '/review-list':'/'">
                                          Review Point 
                                    </router-link>
                              </div>
                              <div v-if="user != '' && user != null" class="col-6 d-flex align-items-center text-white justify-content-end">
                                    <div v-if="user.userLevel === 0" class="mr-2">
                                      <button @click="checkisuserMentor()"  type="button" class="btn btn-outline-light rounded-review">BROWSE MENTORS</button>
                                    </div>
                                    <div class="mr-2">
                                          <a class="text-white cr-pointer" ref="openModal" data-toggle="modal" data-target="#exampleModalLong">
                                                Write a Review
                                          </a>
                                    </div>
                                    <div class="mr-2">
                                          <div class="box-profile">
                                                <img v-if="getProfilePic(user.typeSystem) != ''" class="mw-100" :src="getProfilePic(user.typeSystem)+user.profilePic">
                                                <img v-else class="mw-100" src="@/assets/user.png">
                                          </div>
                                    </div>
                                    <div class="dropdown">
                                      <a class="dropdown-toggle text-white th" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{user.name}} 
                                      </a>

                                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        <a class="dropdown-item cr-pointer" @click="signout()">Sign out</a>
                                      </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
            <div class="bodyPage">
                 <slot></slot>
            </div>
            <div class="modal fade bd-example-modal-lg" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-body">
                        <h3 class="text-center">Write a review</h3>
                        <div class="form-group">
                              <label>
                                  Mentor 
                              </label>    
                              <div>
                                <autocomplete
                                  name="mentorName"
                                  v-validate="'required'"
                                  :placeholder="'Mentor name'"
                                  :source="mentorList"
                                  :class="{'is-validate':errors.has('mentorName')}"
                                  v-model="dataReview.reviewTo">
                                </autocomplete>
                                <div v-show="errors.has('mentorName')" class="text-danger">
                                  Please select mentor
                                </div>
                              </div>
                        </div>
                        <div class="form-group">
                              <label>
                                  Title 
                              </label>    
                              <div>
                                   <input v-model="dataReview.review.title" type="text" class="form-control" name="" placeholder="Title">
                              </div>
                        </div>
                        <div class="form-group">
                              <label>
                                  Detail 
                              </label>    
                              <div>
                                  <textarea v-model="dataReview.review.detail" class="form-control" rows="6"></textarea>
                              </div>
                        </div>
                        <div class="form-group">
                          <b>Rate </b> <span v-for="(data,index) in 5" @click="dataReview.review.rating = index+1,validateRate = false" class="mr-2" :key="index"><i class="fas fa-star" :class="dataReview.review.rating >= (index+1) ? 'text-orange' : 'text-muted'"></i></span>
                          <p class="text-danger" v-if="validateRate == true">Please rate mentor</p>
                        </div>
                        <div class="form-group"> 
                            <div>
                                <label>
                                    <b>Review by </b><span>{{dataReview.review.reviewByName}} </span> <input v-model="dataReview.review.anonymous" type="checkbox" name=""> <span class="text-muted"> Anonymous</span>
                                </label>   
                            </div>
                        </div>
                        <div class="form-group"> 
                          <div class="col-6 mx-auto">
                            <button @click="submitReview()" v-if="validateRate == true" class="btn-comment w-100">SUBMIT</button>
                            <button @click="submitReview()" v-else data-dismiss="modal" class="btn-comment w-100">SUBMIT</button>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
      </div>
      <div v-else>
            <div class="headPage py-3">
                  <div class="container">
                        <div class="row">
                              <div :class="user != '' && user != null ? 'col-sm-12':'col-12 text-center'" class="text-white font-weight-bold font-30 text-center">
                                    <router-link class="text-white" :to="user != '' && user != null ? '/review-list':'/'">
                                          Review Point 
                                    </router-link>
                              </div>
                              <div v-if="user != '' && user != null" class="col-12 d-flex align-items-center text-white justify-content-center">
                                    <div v-if="user.userLevel === 0" class="mr-2">
                                      <button @click="checkisuserMentor()"  type="button" class="btn btn-outline-light rounded-review">BROWSE MENTORS</button>
                                    </div>
                                    <div class="mr-2">
                                          <a class="text-white cr-pointer"  ref="openModal" data-toggle="modal" data-target="#exampleModalLong">
                                                Write a Review
                                          </a>
                                    </div>
                                    <div class="mr-2">
                                          <div class="box-profile">
                                                <img v-if="getProfilePic(user.typeSystem) != ''" class="mw-100" :src="getProfilePic(user.typeSystem)+user.profilePic">
                                                <img v-else class="mw-100" src="@/assets/user.png">
                                          </div>
                                    </div>
                                    <div class="dropdown">
                                      <a class="dropdown-toggle text-white th" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{user.name}} 
                                      </a>

                                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        <a class="dropdown-item cr-pointer" @click="signout()">Sign out</a>
                                      </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
            <div class="bodyPage">
                 <slot></slot>
            </div>
            <div class="modal fade bd-example-modal-lg" ref="my-modal" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-body">
                        <h3 class="text-center">Write a review</h3>
                        <div class="form-group">
                              <label>
                                  Mentor 
                              </label>    
                              <div>
                                <autocomplete
                                  name="mentorName"
                                  v-validate="'required'"
                                  :placeholder="'Mentor name'"
                                  :source="mentorList"
                                  :class="{'is-validate':errors.has('mentorName')}"
                                  v-model="dataReview.reviewTo">
                                </autocomplete>
                                <div v-show="errors.has('mentorName')" class="text-danger">
                                  Please select mentor
                                </div>
                              </div>
                        </div>
                        <div class="form-group">
                              <label>
                                  Title 
                              </label>    
                              <div>
                                   <input v-model="dataReview.review.title" type="text" class="form-control" name="" placeholder="Title">
                              </div>
                        </div>
                        <div class="form-group">
                              <label>
                                  Detail 
                              </label>    
                              <div>
                                  <textarea v-model="dataReview.review.detail" class="form-control" rows="6"></textarea>
                              </div>
                        </div>
                        <div class="form-group">
                          <b>Rate </b> <span v-for="(data,index) in 5" @click="dataReview.review.rating = index+1,validateRate = false" class="mr-2" :key="index"><i class="fas fa-star" :class="dataReview.review.rating >= (index+1) ? 'text-orange' : 'text-muted'"></i></span>
                          <p class="text-danger" v-if="validateRate == true">Please rate mentor</p>
                        </div>
                        <div class="form-group"> 
                            <div>
                                <label>
                                    <b>Review by </b><span>{{dataReview.review.reviewByName}} </span> <input v-model="dataReview.review.anonymous" type="checkbox" name=""> <span class="text-muted"> Anonymous</span>
                                </label>   
                            </div>
                        </div>
                        <div class="form-group"> 
                          <div class="col-6 mx-auto">
                            <button @click="submitReview()" v-if="validateRate == true" class="btn-comment w-100">SUBMIT</button>
                            <button @click="submitReview()" v-else data-dismiss="modal" class="btn-comment w-100">SUBMIT</button>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
      </div>
</div>
</template>
<script>
  import {HTTPTicket,HTTPMentor,HTTPReview} from '@/axios.js'
  import Autocomplete from 'vuejs-auto-complete'
export default {
      data(){
            return{
              urlMentor:process.env.VUE_APP_BASEURL_LINK_MENTOR,
              widthMax:window.innerWidth,
              validateRate:false,
              mentorList:[],
              allMentor:[],
              dataReview:{
                ticket:'',
                reviewTo:'',
                reviewToName:'',
                typeSystem:'',
                review:{
                  reviewExport:'',
                  category:'',
                  title:'',
                  detail:'',
                  rating:0,
                  reviewBy:'',
                  reviewByName:'',
                  reviewBySurname:'',
                  anonymous:false
                }
              },
              proFilePic:process.env.VUE_APP_IMG_PROFILE,
            }
      },
      components:{
        Autocomplete,
      },
      computed:{
            user(){
              return this.$store.state.user
            },
            modalReviewOpen(){
              return this.$store.state.modalReviewOpen
            }
      },
      created(){
        this.fetchData()
        this.dataReview.review.reviewExport = this.user.userExport  
        this.dataReview.review.typeSystem = this.user.typeSystem
        this.dataReview.review.reviewBy = this.user.userId
        this.dataReview.review.reviewByName = this.user.name
        this.dataReview.review.reviewBySurname = this.user.surname 
      },
      mounted() {
        if (this.modalReviewOpen === true) {
          const em = this.$refs.openModal
          em.click()
          this.$store.commit('setmodalReviewOpen',false)
        }

      },
      methods:{
        submitReview(){
          this.$validator.validate().then(result => {
          if(this.dataReview.review.rating == 0){
              this.validateRate = true
          }else{
            let dataMentor = this.allMentor.filter(search =>{
              return search.userId == this.dataReview.reviewTo
            })
            console.log('asdasdsadasdsadsad',this.allMentor[0].userId)
            console.log('dataMentor[0]',dataMentor[0])
            this.$store.commit('this.dataReview',this.dataReview)
            this.$store.commit('setMentorDetail',dataMentor[0])
            HTTPReview.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            HTTPReview.post('/api/create/review',this.dataReview).then(res=>{
                console.log('/api/create/review',res)
                if(res.data.success){
                  this.$router.push('/review-detail')
                  location.reload();
                  this.dataReview={
                    ticket:'',
                    reviewTo:'',
                    reviewToName:'',
                    review:{
                      reviewExport:'',
                      ticket:'',
                      category:'',
                      title:'',
                      detail:'',
                      rating:0,
                      reviewBy:'',
                      reviewByName:'',
                      reviewBySurname:'',
                      anonymous:false
                    }
                  }
                }
                
            })
          }
          });
        },
        fetchData(){
          HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
          HTTPMentor.post(`get/all/user`).then(res => {
            console.log(`get/all/user`,res.data.obj)  
            if(res.data.success){
              this.allMentor = res.data.obj.filter(search =>{
                return search.userLevel == 50
              });
              console.log('this.allMentor',this.allMentor)
              this.$store.commit('setMentorList',this.allMentor)   
              res.data.obj.map(res =>{
                if(res.userLevel == 50 ){
                  this.mentorList.push({id:res.userId,name:res.detailUser[0].name+' '+res.detailUser[0].surname})
                }
              })

            }
          }).catch(e => {
            console.log("get/all/user/error",e);
            this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
          });
        },
        signout(){
          setTimeout(() => {
            window.localStorage.clear();
          }, 100);
          this.$store.commit("clearlogin");
          window.localStorage.removeItem("review");
          this.$router.push("/");
        },
        getProfilePic(type){
          console.log('getProfilePic',type)
          let path = ''
          if(type == 'mentor'){
            path = process.env.VUE_APP_IMG_PROFILE_MENTOR
          }else if(type == 'integreat'){
            path = process.env.VUE_APP_IMG_PROFILE_INTEGREAT
          }else if(type == "ticket"){
            path = process.env.VUE_APP_IMG_PROFILE_TICKET
          }
          return path
        },
        checkisuserMentor(){
            let text = JSON.stringify(this.user)
            let input = JSON.parse(text)
            console.log('input',input)
            let obj ={
              businessData: input.businessData,
              detailUser: [input.detailUser],
              email: input.detailUser.email,
              name: input.detailUser.name,
              objectTelephoneNumber: input.detailUser.objectTelephoneNumber,
              profilePic: input.detailUser.profilePic,
              surname: input.detailUser.surname,
              token: input.token,
              typeSystem: input.typeSystem,
              typeSystemId: '',
              uid: "",
              userExport: input.userId,
              userId: input.userId,
              userLevel: input.userLevel
            }

            console.log('obj',obj)
            var jwt = require('jsonwebtoken');
            var secret = 'dFvsdd125ssE'
            var token = jwt.sign({ 
              token:this.user.token,
              obj:obj
            }, secret);
            window.open(this.urlMentor+'token/'+token, '_blank');
        }
      }
}
</script>
<style scope>
  .headPage{
        background-color: #FFA800;
        font-family:'Raleway', sans-serif;
  }
  .box-profile{
        width: 60px;
        height: 60px;
        overflow: hidden;
        border-radius: 50%;
        background: #fff;
        border:1px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
  }
  .autocomplete__box{
      display: block;
      width: 100%;
      height: calc(1.5em + .75rem + 2px);
      padding: .375rem .75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: .25rem;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
  
</style>